import { Container, Typography } from "@mui/material";
import styled from "styled-components";

export const StyledBox = styled.footer`
  && {
    position: relative;
    width: 100%;
    margin: 0 auto;
  }
`;

export const ContainerGrid = styled(Container)`
  && {
    max-width: 1024px;
    padding-top: 5px;
    padding-bottom: 15px;
  }
`;

export const AnsImageLink = styled.a`
  && {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    cursor: pointer;
  }
`;

export const Rights = styled(Typography).attrs({ as: "p" })`
  && {
    font-family: Figtree, sans-serif;
    font-size: 13px;
    line-height: 20px;
    color: #6d6d6d;
    text-align: center;
    display: block;
    margin: 0;
  }
`;

export const IconImage = styled.img`
  && {
    padding: 3px;
    display: inline-block;
    max-width: 100%;
    height: auto;
    vertical-align: middle;
  }
`;
